<script setup>
import { ref, computed, watch, onMounted, onUnmounted, nextTick } from "vue";
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import LocalStorage from '@/controller/LocalStorage.js';
import YBtn from "../../common/form/YBtn/YBtn.vue";
import WorkfileReparationTime from "./components/WorkfileReparationTime.vue";
import WorkfileActions from "./components/WorkfileActions.vue";
import WorkfileStatusList from "./components/WorkfileStatusList.vue";
import WorkfileVehicleLogo from "./components/WorkfileVehicleLogo.vue";
import WorkfileVehicleInfo from "./components/WorkfileVehicleInfo.vue";
import WorkfilesDates from "./components/WorkfilesDates.vue";
import WorkfilesClient from "./components/WorkfilesClient.vue";
import WorkfilesBranch from "./components/WorkfilesBranch.vue";
import WorkfileInvoices from "./components/WorkfileInvoices.vue";
import WorkfileDocuments from "./components/WorkfileDocuments.vue";
import WorkfileMedia from "./components/WorkfileMedia.vue";
import { templateRef } from "@vueuse/core";
import { ws_base } from '@/conf/conf.js';




const back = '/assets/workfiles/back.svg';
const props = defineProps({
  workfile: Object
});

const infoRef = ref(null);
const actionsRef = ref(null);
const infoHeight = ref(0);
const isActionsActive= ref(true);
const router = useRouter();

const userKey = ref(LocalStorage.getKey());
const path =  router.currentRoute.value.params.id;


const mediaNumber = computed(() => {
  return props.workfile?.data?.media?.length || 0;
});



const updateHeight = () => {
    if (infoRef.value) {
        infoHeight.value = infoRef.value.offsetHeight;
    }
    
};

const isExpanded = ref(false);
const toggleExpand = () => {
        
    isExpanded.value = !isExpanded.value;
      
};

watch(isExpanded, async () => {
    await nextTick(); // Esperar a que el DOM actualice la UI
    updateHeight();
});

const toggleExpandAll = () => {
  isExpanded.value = !isExpanded.value;
 
};
const isMobileView = ref(()=> window.innerWidth <= 576);
const isVerticalTabletView = ref(()=> window.innerWidth > 576 && window.innerWidth <= 768);
const isDesktopView = ref(()=> window.innerWidth > 768);
const updateView = () => {
  isMobileView.value = window.innerWidth <= 576;
  isVerticalTabletView.value = window.innerWidth > 576 && window.innerWidth <= 768;
  isDesktopView.value = window.innerWidth > 768;
};

onMounted(() => {
    window.addEventListener('resize', updateView);
    updateView();
});
onUnmounted(() => {
  window.removeEventListener('resize', updateView);
  
});

const userColor = ref(LocalStorage.getColor());
const { t } = useI18n();
const show = ref(false);

const less = "/assets/svg/-.svg";
const more = "/assets/svg/+.svg";


watch(() => props.workfile, () => {
  if(props.workfile){
    show.value = true;
  }
});






</script>

<template>
    <div v-if="isMobileView" class="background-saver"></div>
    <div class="workfile-body-wrapper" v-if="show">
        <div class="navigation-wrapper">
            <YBtn class="navigation" @click="$router.go(-1)" variant="link" :noUnderline="true"
                contentClass="navigation">
                <img :src="back" alt="" style="height:1rem;  margin-right: 0.5rem;">
                <span>{{ $t('field.back') }}</span>
            </YBtn>
        </div>
        <div class="workfile-body">
            <div v-if="isMobileView" class="icon-wrapper" @click="toggleExpand"
                style="justify-content: center; align-items: center;">

                <div class="icon" :class="{ expanded: isExpanded }" :style="{ top: `${infoHeight + 65}px` }">
                    <span v-if="!isExpanded"><img :src="more" style="width: 18px;" /></span>
                    <span v-else><img :src="less" style="width: 18px; height: 30px;" /></span>
                </div>
                <div class="line" :class="{ expanded: isExpanded }" :style="{ height: `${infoHeight + 65}px` }"></div>
            </div>
            <div v-if="isMobileView" class="body-mobile-info" ref="infoRef" :class="{ 'show': isExpanded }">
                <div class="workfile-dates">
                    <WorkfilesDates :modified="props.workfile?.date" :schedule="props.workfile?.scheduleDate"
                        :reparation="props.workfile?.reparationDate" :delivery="props.workfile?.deliveryDate"
                        :type="props.workfile?.type" :reparationTime="props.workfile?.reparationTime" />
                </div>
                <div class="workfile-client">
                    <WorkfilesClient :client="props.workfile?.client" />
                </div>

                <div class="workfile-branch">
                    <WorkfilesBranch :branch="props.workfile?.data?.branch" :isMobileView="isMobileView" />
                </div>

                <div class="workfile-documents">
                    <WorkfileDocuments :invoices="props.workfile?.data?.invoices"
                        :documents="props.workfile?.data?.documents" />
                </div>
                <div class="workfile-media">
                    <WorkfileMedia :media="props.workfile?.data?.media" :isMobileView="isMobileView" :mediaNumber="mediaNumber" @download-click="downloadMedia"/>
                </div>
                <div class="workfile__body_content body-padding">
                    <YautyTable :offset="offset" :limit="limit" :sort="sort" :dir="dir" :headers="headers"
                        :items="listWorkfiles" :total="totalWorkfiles" :page="listPage" :render="'server'"
                        :filters="filters" :isLoading="workfilesLoading" :expandable="true" :filtrable="true"
                        :pagination="true" :columnSelector="true" table="workfilesList" @callLoadPage="loadPage"
                        @filterChanged="filterChanged" @toggleExpand="toggleExpand" @sortChanged="sortChanged" />
                </div>
            </div>
            <div v-if="isMobileView" class="body-mobile-actions" ref="actionsRef" :class="{ expanded: isExpanded }"
                :style="{ top: `${infoHeight + 100}px` }">
                <WorkfileActions :actions="props.workfile?.actions" :outOfStock="props.workfile?.outOfStock" />
            </div>
            <div class="workfile-vehicle-logo-container">
                <WorkfileVehicleLogo :vehicle="props.workfile?.vehicle" />
            </div>
            <div class="workfile-vehicle-info">
                <WorkfileVehicleInfo :vehicle="props.workfile?.vehicle" :or="props.workfile?.orNumber"
                    :runningHours="props.workfile?.runningHours" />
            </div>
            <div class="workfile-dates">
                <WorkfilesDates :modified="props.workfile?.date" :schedule="props.workfile?.scheduleDate"
                    :reparation="props.workfile?.reparationDate" :delivery="props.workfile?.deliveryDate"
                    :type="props.workfile?.type" :reparationTime="props.workfile?.reparationTime" />
            </div>
            <div class="workfile-client">
                <WorkfilesClient :client="props.workfile?.client" />
            </div>
            <div class="workfile-branch">
                <WorkfilesBranch :branch="props.workfile?.data?.branch" />
            </div>
            <div class="workfile-actions-wrapper">
                <div class="subtitle" style="z-index:1;">
                    <button class="actions-title" :class="{ inactive: !isActionsActive }" @click="isActionsActive = true">
                        {{ t('actions.actions') }}
                    </button>
                    <button class="media-title" :class="{ inactive: isActionsActive }"  @click="isActionsActive = false" :disabled="mediaNumber === 0">
                        Media
                    </button>
                    <div class="media-number">{{ mediaNumber }}</div>
                </div>
                <WorkfileActions v-if="isActionsActive" :actions="props.workfile?.actions"
                    :outOfStock="props.workfile?.outOfStock" />

                <div v-else class="media-container" style="height: 100%;">
                    <WorkfileMedia :media="props.workfile?.data?.media"  :mediaNumber="mediaNumber"/>
                    <YBtn class="download-button" :rounded="true" roundedSize="full" size="xs" :target="_self" :href="`${ws_base}/workfile/${path}/medias?token=${userKey}`">
                        <div style="margin-right: 8px;">
                            <img src="/public/assets/workfiles/download.svg" style="margin-right: 8px; margin-bottom: 10px; margin-left: 8px; margin-top: 4px; height: 1rem;" />
                            {{ t('workfiles.download_zip') }}
                        </div>
                        
                    </YBtn>
                    
                </div>
            </div>
            <div class="workfile-invoices">
                <WorkfileInvoices :invoices="props.workfile?.data?.invoices" />
            </div>
            <div class="workfile-reparation-time-wrapper defaultScreen">
                <WorkfileReparationTime :time="props.workfile?.reparationTime"
                    :statusLog="props.workfile?.data?.workfile_status_log" :type="props.workfile?.type" />
            </div>
            <div class="workfile-status-line-wrapper defaultScreen">
                <WorkfileStatusList :log="props.workfile?.data?.workfile_status_log"
                    :documents="props.workfile?.data?.documents" :type="props.workfile?.type" />
            </div>
            <div class="status-container" :class="{ expanded: isExpanded }">
                <WorkfileReparationTime :time="props.workfile?.reparationTime"
                    :statusLog="props.workfile?.data?.workfile_status_log" :type="props.workfile?.type"
                    :isExpanded="isExpanded" @toggle-expand="toggleExpandAll" />
                <div class="status-container-scroll">
                    <WorkfileStatusList :log="props.workfile?.data?.workfile_status_log"
                        :documents="props.workfile?.data?.documents" :type="props.workfile?.type"
                        :isExpanded="isExpanded" @toggle-expand="toggleExpandAll" />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

.media-container{
    display: flex;
    flex-direction: column;
    align-items: end;

   
}

.download-button{
    margin-right: 5rem
}

.subtitle{
    margin-top: 1.5rem;
    padding-left: 5rem;
    font: normal normal normal 22px/19px 'CircularStd-Bold';
    letter-spacing: 0px;
    color: #153440;
    opacity: 1;
    position: absolute;
    display: flex;
    flex-direction: row;
    z-index: 10;
    transition-duration: 1s;
    .media-title{
        margin-left: 1rem;
        font: normal normal normal 22px/19px 'CircularStd-Bold';
        letter-spacing: 0px;
        color: #153440;
        opacity: 1;
        
    }
    .inactive {
        opacity: 0.42; /* Cambiar el color a gris para el estado inactivo */
    }
    .media-number{
        background-color: v-bind(userColor);
        color: white;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        margin-left: 0.1rem;
    }

    .media-title.disabled {
        cursor: not-allowed;
    }

}


.background-saver {
    height: 125%;
    width: 100%;
    background-color: #EFF3F3;
    position: absolute;
    z-index: -5;
    margin-left: -50px;
}
.body-mobile-info, .status-container, .body-mobile-actions{
    display: none;
}
.navigation-wrapper{
    display: flex;
    justify-content: start;
    align-items: center;
    padding-bottom: 5px;
    height: 40px;
    padding-left: 10px;
    .navigation{
        display: flex;
        gap: 1rem;
        align-items: center;
        & *{
            color: #7E8E94;
        }
        padding-bottom: 0;
        width: fit-content;
    }
    .navigation:hover{
        cursor: pointer;
        img {
            animation: arrow 700ms linear infinite;
        }
    }
}
@keyframes arrow {
    0% {right: 0px}
    50% {right: 10px}
    100% {right: 0px}
}
.workfile-body{
    border-radius: 25px;
    display: grid;
    flex-direction: row;
    background-color: white;
    
    padding-bottom: 2rem;
    padding-right: 3rem;
    
    @media only screen and (max-width: 686px) {
        grid-template-columns:48% 48% 1fr;
        grid-template-rows: 50px 1fr;
        grid-template-areas: 
        ".                .                 ."
        "vehicle-logo     dates             ."
        "vehicle-info     vehicle-info      ." 
        "client           branch            ."
        "invoices         .                 ."
        "actions          actions           ."
        "status-line      status-line       .";
    }
    @media only screen and (max-width: 1366px) {
        grid-template-columns:48% 30% 1fr;
        grid-template-rows: 50px 1fr;
        grid-template-areas: 
        ".                .                 ."
        "vehicle-logo     dates             ."
        "vehicle-info     .                 ." 
        "client           branch            ."
        "invoices         .                 ."
        "actions          actions           ."
        "status-line      status-line       .";
    }
    @media (min-width: 769px) and (max-width: 990px) and (orientation: landscape) {
        grid-template-columns:40% 30% 1fr;
        grid-template-rows: 50px 1fr;
        grid-template-areas: 
        ".                .                 ."
        "vehicle-logo     dates             ."
        "vehicle-info     .                 ." 
        "client           branch            ."
        "invoices         .                 ."
        "actions          actions           ."
        "status-line      status-line       .";
    }
   
    @media only screen and (max-width: 1280px) and (orientation:portrait){
        grid-template-columns:48% 48% 1fr;
        grid-template-rows: 50px 1fr;
        grid-template-areas: 
        ".                .                 ."
        "vehicle-logo     dates             ."
        "vehicle-info     .                 ." 
        "client           branch            ."
        "invoices         .                 ."
        "actions          actions           ."
        "status-line      status-line       .";
    }
    @media only screen and (min-width: 1366px) {
        grid-template-columns: 213px 180px 215px 1fr 0.7fr 101px 250px;

        .workfile-vehicle-logo-container{
            left: 4rem;
            top: 1rem;
        }

        // grid-template-rows: 50px minmax(100px, 200px) 50px 1fr 50px;
        grid-template-areas: 
        ".            .            .            .            .            .         reparation-time" 
        "vehicle-logo vehicle-info dates        client       branch       invoices  status-line"    
        "actions      actions      actions      actions      actions      actions   status-line"
        ".            .            .            subtotal     subtotal     .         status-line";
    }
    @media only screen and (min-width: 1680px) {
        grid-template-columns: 250px 195px 225px 250px 300px 150px 300px;
        .workfile-vehicle-logo-container{
            left: 4rem;
            top: 1rem;
        }
    }


    .workfile-navigation-wrapper{
        grid-area: navigation;
        justify-self: end;
        align-self: start;
        padding-top: 1rem;

    }
    .workfile-navigation-wrapper:hover{
        cursor: pointer;
    }
    .workfile-info-wrapper{
        grid-area: general-info;
    }
    .workfile-actions-wrapper{ 
        margin-top: 1.5rem;
        grid-area: actions;
    }
    .workfile-reparation-time-wrapper{
        grid-area: reparation-time;
    }
    .workfile-status-line-wrapper{
        grid-area: status-line;
    }
    .workfile-actions-total-wrapper{
        grid-area: subtotal;
    }
    .workfile-vehicle-logo-container{
        grid-area: vehicle-logo;
    }
    .workfile-vehicle-info{
        grid-area: vehicle-info;
    }
    .workfile-dates{
        grid-area: dates;
        margin-top: 3px;
    }
    .workfile-client{
        grid-area: client;
    }
    .workfile-branch{
        grid-area: branch;
    }
    .workfile-invoices{
        grid-area: invoices;
    }
}

@media (max-width:576px) {
    .workfile-client, .workfile-branch, .workfile-dates, .workfile-actions-wrapper, .workfile-reparation-time-wrapper,.workfile-status-line-wrapper, .workfile-invoices{
        display: none;
    }
    .body-mobile-info{
        .workfile-client, .workfile-branch, .workfile-dates, .workfile-actions-wrapper, .workfile-reparation-time-wrapper,.workfile-status-line-wrapper, .workfile-documents{
            display: block;
        }
    }
    .navigation-wrapper{
        display: none;
    }
    .workfile-body {
        background-color: transparent;
    }
    .workfile-reparation-time-wrapper{
        display: none;
    }
    .workfile-vehicle-logo-container{
        display: none;
    }
    .icon-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    position: relative;
    }
    .icon{
        position: absolute;
        z-index: 5;
        left: -30.5px;
        display: flex;
        padding-top: 1px;
        // align-items: center;
        justify-content: center;
        background-color: #07CCB9;
        border-radius: 100%;
        width: 31px;
        height: 31px; 
        transition: top 0.3s;
        top: 40%;
    }
    .line {
    position: absolute;
    left: -16px;
    width: 2px;
    height: 100px;
    top: 40%;
    background-color: #07CCB9; 
    transition: height 0.3s;
    }

    .line.expanded {
    height: 540px; 
    }
    .body-mobile-info {
        display: block;
        position: absolute;
        height: auto;
        top: 95px;
    }
    .workfile-body .workfile-client{
        right: 17.5px;
    }
    .workfile-branch {
        padding-left: 0.4rem;
    }
    .body-mobile-info{
        opacity: 0;
        transition: opacity 0.3s ease;
        height: 0;
        overflow: visible;
    }
    .body-mobile-info.show {
        opacity: 1;
        height: auto;
        }
        
    .body-mobile-actions{
        display: block;
        position: absolute;
        background-color: #EFF3F3;
       
        left: -55px;
        transition: top 0.15s ease-in-out;
    }
    .workfile-documents{
        padding-left: 1rem;
    }
    
}

@media (min-width: 577px) and (max-width: 1280px) and (orientation:portrait){
    
    ::-webkit-scrollbar {
    width: 2px !important; 
    }
    ::-webkit-scrollbar-thumb {
    background: #8D939E; 
    }
    ::-webkit-scrollbar-thumb:hover {
    background: #555 !important; 
    }
    ::-webkit-scrollbar-track {
    background: #E5E8EC;
    }
    .defaultScreen, .body-mobile-actions{
        display: none;
    }
    .status-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        position: absolute;
        right: 16px;
        min-width: 80px;
    }
    .status-container-scroll{
        padding-right: 10px;
        max-height: 488px;
        overflow-y: auto;
    }
    .status-container.expanded{
        right: 0;
        min-width: 232px;
        background-color: #FFFFFF !important;
        z-index: 999;
        border-radius: 24px;
        box-shadow: 0px 0px 18pt rgba(0, 0, 0, 0.2);
    }
    .workfile-body-wrapper{
        padding-top: 7dvh;
        height: 100dvh;
        .navigation-wrapper{
            justify-content: end;
            padding-right: 25px;
            margin-bottom: 15px;
            padding-top: 15px;
        }
        .workfile-client, .workfile-invoices{
            padding-left: 1.5rem;
        }
        .workfile-branch{
            padding-left: 0.5rem;
        }
        .workfile-vehicle-logo-container{
            display: flex;
            justify-content: center;
            align-items: center;
            padding-left: 0;
            left: 35px;
            width: 50px;
            height: 50px;
        }
    
    }
}

@media (min-width: 769px) and (max-width: 1367px) and (orientation: landscape) {
    ::-webkit-scrollbar {
    width: 3px !important; 
    }
        
    ::-webkit-scrollbar-thumb:hover {
    background: #555 !important; 
    }
    .defaultScreen{
        display: none;
    }
    .status-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        position: absolute;
        right: 30px;
        width: 232px;
    }
    .status-container-scroll{
        padding-right: 10px;
        max-height: 488px;
        overflow-y: auto;
    }
    .workfile-body-wrapper{
        .navigation-wrapper{
            justify-content: end;
            padding-right: 25px;
            margin-bottom: 15px;
        }
        .workfile-client, .workfile-invoices{
            padding-left: 1.5rem;
            top: 0px;
        }
        .workfile-branch{
            padding-left: 0.5rem;
            top: -30px;
        }
    }
    
}

@media (min-width: 768px) and (max-width: 1367px) and (orientation: portrait) {
    .download-button{
        margin-right: 2rem;
    }
  
  
}

@media (min-width: 1024px) and (max-width: 1400px) and (orientation: landscape) {
 
    .download-button{
        margin-right: 3rem;
    }
  
  
}

@media (max-width:400px) and (orientation:portrait){
    .background-saver {
    height: 150%;
    width: 100%;
    background-color: #EFF3F3;
    position: absolute;
    z-index: -5;
    margin-left: -50px;
}
}


</style>